























































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Box from '../components/Box.vue'
import api from "../../api/index"
import { Action } from 'vuex-class'

@Component({
  components: {
    'box': Box
  }
})

export default class Login extends Vue {
  email = ""
  password = ""
  emailSubmitted = ""
  apiError = false
  imgUrl = 'backgroundImage.jpg'
  showPassword = false

  @Action('createSession') createSession:any

  get formIsValid() {
    const emailIsValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
    if (emailIsValid && this.password) {
      return true
    } else {
      return false
    }
  }

  async logIn() {
    if (this.formIsValid) {
      const params = {
        grant_type: "password",
        // client_id: "c7abaf3a21b3ef5533a893e0d354d3fc9694ddbf2c4631b443292925f9a861be",
        // client_secret: "a7368b48802f9a8e4ad8896e03dc0b34d14d0bc44f74d040ecb0d1dcc3badb8d",
        username: this.email,
        password: this.password
      }
      try {
        const res = await api.post("oauth/token", params)
        this.createSession(res.data.access_token)
        this.$router.push({name: "sites"})
      } catch (e) {
        if (e.response.status === 401) {
          console.log(e.response.status)
          this.apiError = true
          this.emailSubmitted = this.email
        }
      }
    }
  }
}
